module.exports = __webpack_public_path__ + "img/logo1.14546def.png";